
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transactions/msg",
      function () {
        return require("private-next-pages/transactions/msg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transactions/msg"])
      });
    }
  